import { Modal } from "bootstrap";
import ApiService from "@/services/ApiService";
import Swal from "sweetalert2";
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import tinymce from 'tinymce';
import { ref } from "vue";
import JwtService from "@/services/JwtService";
import axios from "axios";

const privileges = ref<string[]>(JwtService.getPrivilege() as string[]);

const initTinyMCE = (target, config) => {
  return tinymce.init({
    target,
    ...config,
  });
};

export const getUrlApiForFiles = (dossier: string | null, nomFichier: string | null) => {
  if (dossier) {
    const url = `${ApiService.vueInstance.axios.defaults["updateUrl"]}uploads/${dossier}/${nomFichier}`;
    return url;
  } else {
    return `${ApiService.vueInstance.axios.defaults["updateUrl"]}uploads/Erreur404.pdf`;
  }
}

export const checkPrivilege = (name): boolean => {
  return privileges.value.includes(name);
}

export const downloadExcel = async (route:string) => {
  try {
    // Configurer les en-têtes d'authentification
    const token = JwtService.getToken();
    const response = await axios.get(route, {
      responseType: "blob", // Pour gérer un fichier binaire
      headers: {
        'Authorization': `Bearer ${token}`,
        'Accept': 'application/json'
      }
    });
    // Créer un lien temporaire pour le téléchargement
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "monFichier.xlsx"); // Nom du fichier
    document.body.appendChild(link);
    link.click();
    // Nettoyage
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (er) {
    //error("Une erreur s'est produite lors du téléchargement du fichier.");
    console.error("❌ Erreur lors du téléchargement :", error);
  }
};
const decouperEtJoindre = (chaine: string, separateur: string, nombreCaratere: number): string => {
  const blocs: string[] = [];
  for (let i = 0; i < chaine.length; i += nombreCaratere) {
    blocs.push(chaine.substring(i, i + nombreCaratere));
  }
  return blocs.join(separateur);
}

const getDatePlusXDays = (x: number) => {
  const currentDate = new Date();
  const futureDate = new Date();

  futureDate.setDate(currentDate.getDate() + x);
  // Obtenez les composants de la date
  const year = futureDate.getFullYear();
  const month = (futureDate.getMonth() + 1).toString().padStart(2, '0'); // Les mois commencent à 0
  const day = futureDate.getDate().toString().padStart(2, '0');

  // Formattez la date comme "YYYY-MM-DD"
  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
}

const destroyTinyMCE = (editor) => {
  if (editor) {
    editor.destroy();
  }
};

function differenceDeuxArray(arr1, arr2) {
  const set = new Set(arr2);
  const difference = arr1.filter(element => !set.has(element));
  return difference;
}

const transformeDeuxNombreEnTableauIntervalle = (deb, fin) => {
  if (deb > fin) {
    throw new Error("Le début de l'intervalle ne peut pas être supérieur à la fin.");
  }
  const result: number[] = [];

  for (let i = parseInt(deb); i <= parseInt(fin); i++) {
    result.push(i);
  }
  return result;
}


const hideModal = (modalEl: HTMLElement | null): void => {
  if (!modalEl) {
    return;
  }

  const myModal = Modal.getInstance(modalEl);
  myModal?.hide();
};

const showModal = (modalEl: HTMLElement | null): void => {
  if (!modalEl) {
    return;
  }
  const myModal = new Modal(modalEl);
  myModal?.show()
};



const success = (message) => {
  Swal.fire({
    title: 'Succès',
    text: message,
    icon: "success",
    toast: true,
    timer: 5000,
    position: 'top-right',
    showConfirmButton: false,
  });
}

const warning = (message, time = 5000) => {
  Swal.fire({
    title: 'Attention',
    text: message,
    icon: "warning",
    toast: true,
    timer: time,
    position: 'top-right',
    showConfirmButton: false,
  });
}

const error = (message, time = 5000) => {
  Swal.fire({
    title: 'Erreur',
    html: message,
    icon: "error",
    toast: true,
    timer: time,
    position: 'top-right',
    showConfirmButton: false
  });
}

// function getMonthsWithinRange(nombreDeMois: number): string[] {
//   // Liste des mois en français
//   const mois = [
//     "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
//     "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
//   ];

//   // Mois en cours (1-based index, donc -1 pour s'aligner avec l'index de tableau)
//   const moisCourant = new Date().getMonth() + 1;
//   let lesxDernierMois;
//   let derniersMois: string[];
//   const moisInverses = [...mois].reverse();

//   for(let i = 1 ; i <= nombreDeMois; i++){
//     lesxDernierMois.push((moisInverses[i]));
//   }

//   if(lesxDernierMois.includes(mois[moisCourant-1])){
//     const index = lesxDernierMois.indexOf(mois[moisCourant-1]);
//     derniersMois = lesxDernierMois.slice(index);
//   }

//   return derniersMois;
// }

function getMonthsWithinRange(nombreDeMois: number): string[] {
  // Liste des mois en français
  const mois = [
    "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
    "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
  ];

  // Mois en cours (1-based index, donc -1 pour s'aligner avec l'index de tableau)
  const moisCourant = new Date().getMonth() + 1;

  const lesxDernierMois: string[] = [];  // Initialiser comme tableau vide
  let derniersMois: string[] = [];     // Initialiser comme tableau vide
  const moisInverses = [...mois].reverse();

  // Remplir lesxDernierMois
  for (let i = 0; i <= (nombreDeMois - 1); i++) {
    lesxDernierMois.push(moisInverses[i]);
  }

  // Vérification et récupération des mois à partir de l'index du mois courant
  if (lesxDernierMois.includes(mois[moisCourant - 1])) {
    const index = lesxDernierMois.indexOf(mois[moisCourant - 1]);
    derniersMois = lesxDernierMois.slice(index); // Récupérer les mois à partir de l'index trouvé
  } else {
    derniersMois = [...lesxDernierMois].reverse();
  }

  return derniersMois;
}

function getMonthsWithinRange2(nombreDeMois: number): string[] {
  // Liste des mois en français
  const mois = [
    "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
    "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
  ];

  // Mois en cours (1-based index, donc -1 pour s'aligner avec l'index de tableau)
  const moisCourant = 12;

  const lesxDernierMois: string[] = [];  // Initialiser comme tableau vide
  let derniersMois: string[] = [];     // Initialiser comme tableau vide
  const moisInverses = [...mois].reverse();

  // Remplir lesxDernierMois
  for (let i = 0; i <= (nombreDeMois - 1); i++) {
    lesxDernierMois.push(moisInverses[i]);
  }

  // Vérification et récupération des mois à partir de l'index du mois courant
  if (lesxDernierMois.includes(mois[moisCourant - 1])) {
    const index = lesxDernierMois.indexOf(mois[moisCourant - 1]);
    derniersMois = lesxDernierMois.slice(index); // Récupérer les mois à partir de l'index trouvé
  } else {
    derniersMois = [...lesxDernierMois].reverse();
  }

  return derniersMois;
}

const format_date = (value, p0: string) => {
  if (value) {
    return format(new Date(value), 'dd-MM-yyyy HH:mm', { locale: fr });
    //return moment(String(value)).format('DD-MM-YYYY hh:mm')
  }
}
const format_Date = (date) => {
  if (date) {
    return format(new Date(date), 'dd-MM-yyyy', { locale: fr });
  }
}

export const reformat_Date = (date) => {
  if (date) {
    return format(new Date(date), 'yyyy-MM-dd', { locale: fr });
  }
}

const separateur = (montant) => {
  if (montant === undefined || montant === null || isNaN(montant)) {
    return ''; // Retourne une chaîne vide pour les cas non valides
  }
  return montant.toLocaleString('fr-FR', {
    minimumFractionDigits: 0, // Supprime les décimales inutiles
    maximumFractionDigits: 2, // Permet jusqu'à 2 décimales
  });
};

const removeModalBackdrop = (): void => {
  if (document.querySelectorAll(".modal-backdrop.fade.show").length) {
    document.querySelectorAll(".modal-backdrop.fade.show").forEach((item) => {
      item.remove();
    });
  }
};
function nomBreMoisAnneeEntame(): number {
  const today = new Date();
  const currentMonth = today.getMonth() + 1; // Mois actuel (1 = Janvier, 12 = Décembre)

  return currentMonth; // Le nombre de mois écoulés ou entamés dans l'année
}

const recuperLesMoisDu = (dueMonths: number, referenceDate = new Date()): string[] => {
  const months = [
    "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
    "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
  ];
  const currentMonth = referenceDate.getMonth();
  const startMonth = Math.max(0, currentMonth - dueMonths + 1);
  const remainingMonths: string[] = [];
  for (let i = startMonth; i <= currentMonth; i++) {
    remainingMonths.push(months[i]);
  }

  return remainingMonths;
}


const getAssetPath = (path: string): string => {
  return '' + path;
};


const suppression = (id: number, element: any, route: string, entite: string) => {
  Swal.fire({
    text: "Vous êtes sur le point de supprimer " + entite + ". Etes-vous sûr ?",
    icon: "warning",
    buttonsStyling: true,
    showCancelButton: true,
    confirmButtonText: "Supprimer",
    cancelButtonText: `Annuler`,
    heightAuto: false,
    customClass: {
      confirmButton: "btn btn-danger",
    },
  }).then(async (result) => {
    if (result.isConfirmed) {
      await ApiService.delete(`/${route}/${id}`)
        .then(({ data }) => {
          Swal.fire({
            title: 'Succès',
            text: data.message,
            icon: "success",
            toast: true,
            timer: 5000,
            position: 'top-right',
            showConfirmButton: false,
          });
          for (let i = 0; i < element.length; i++) {
            if (element[i].id === id) {
              element.splice(i, 1);
            }
          }
        }).catch(({ response }) => {
          Swal.fire({
            text: response.data.message, //'Oups il y a un problème',//
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Réssayer à nouveau!",
            heightAuto: false,
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    } else if (result.isDenied) {
      Swal.fire("La suppression n'est pas passée", "", "info");
    }
  });
};



async function telechargerFichier(nomFichier, donnees) {
  const blob = new Blob([donnees], { type: 'application/pdf' });

  // Création d'une URL pour le Blob
  const url = window.URL.createObjectURL(blob);

  try {
    const link = document.createElement('a');
    link.href = url;
    link.download = nomFichier;
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.error('Une erreur s\'est produite lors du téléchargement du fichier :', error);
  } finally {
    window.URL.revokeObjectURL(url);
  }
}
const telechargerFichier2 = async (fin: string, nomFichier: string) => {
  const ele = "rien";
  await ApiService.get(`/telecharger?nomFichier=${nomFichier}&fin=${fin}&ele=${ele}`)
    .then(response => {
      telechargerFichier(nomFichier, response.data)
    })
    .catch(error => {
      console.error('Une erreur s\'est produite lors du téléchargement du fichier :', error);
    });
}

const trouverPartieDecimaleEtConvertir = (value) => {
  // Vérifie si la valeur est un nombre
  if (typeof value !== 'number') {
    error("Veuillez saisir un nombre");
    return;
  }
  const value2 = value.toString();

  // Récupère la partie décimale en soustrayant la partie entière
  const decimal = value - Math.floor(value);

  // Vérifie si la partie décimale est différente de zéro
  if (decimal !== 0) {
    return parseFloat(value2);
  } else {
    return parseInt(value2);
  }
}
const trouverObjetParId = (tableau, idRecherche) => {
  return tableau.find(objet => objet.id === idRecherche);
}
const trouverObjetParId2 = (tableau, idRecherche) => {
  return tableau.find(objet => objet.arr_id === idRecherche);
}
const dateActuelle = () => {
  const dateActuelle: Date = new Date();

  const annee: number = dateActuelle.getFullYear();
  const mois: number = dateActuelle.getMonth() + 1; // Les mois commencent à partir de 0
  const jour: number = dateActuelle.getDate();

  const dateHeureActuelle = `${annee}-${mois}-${jour}`;

  return dateHeureActuelle;
}

const elementsNonCommuns = (tableau1: any[], tableau2: any[]): any[] => {
  const resultat: any[] = [];
  tableau1.forEach((element) => {
    if (!tableau2.includes(parseInt(element))) {
      resultat.push(element);
    }
  });
  return resultat;
}

const supprimerElement = (valeurASupprimer: number, tableau: any[]) => {
  const element = tableau;
  tableau = [];
  tableau = element.filter(el => el !== valeurASupprimer);
  return tableau;
};

const convertirEnNombre = (min: number, max: number, tableau: number[]): number[] => {
  tableau = [];
  for (let i = min; i <= max; i++) {
    tableau.push(i);
  }
  return tableau;
}

const afficher20Caracteres = (value: string | undefined, limit = 20, suffix = '...'): string => {
  if (!value) { return '-' } else {
    return value.length > limit ? value.slice(0, limit) + suffix : value;
  }

}

export const checkPermission = (name: string): boolean => {
  return privileges.value.includes(name);
}

const privileges2 = ref<Array<string>>(JwtService.getPrivilege());

const checkPermission2 = (name) => {
  return privileges2.value.includes(name);
}

export const checkParentPermission = (permissions) => {
  for (const permission of permissions) {
    if (checkPermission2(permission)) {
      return true; 
    }
  }
  return false; 
}

export {
  afficher20Caracteres,
  getDatePlusXDays, getMonthsWithinRange, getMonthsWithinRange2, recuperLesMoisDu, nomBreMoisAnneeEntame, transformeDeuxNombreEnTableauIntervalle, differenceDeuxArray, convertirEnNombre, elementsNonCommuns, supprimerElement, dateActuelle, trouverObjetParId2, trouverPartieDecimaleEtConvertir, trouverObjetParId, decouperEtJoindre, telechargerFichier2, removeModalBackdrop, suppression, separateur, hideModal, getAssetPath, format_Date, showModal, format_date, warning, success, error, initTinyMCE, destroyTinyMCE,
};

